import {
    PUBLIC_DATA_REQUEST,
    PUBLIC_DATA_OK,
    PUBLIC_DATA_ERROR,
    PUBLIC_REVOKE_REQUEST,
    PUBLIC_REVOKE_OK,
    PUBLIC_REVOKE_ERROR,
} from "../action/shareDataActionsPublic"

const initialState = {
    loadCompleted: false,
    successfullyLoaded: null,
    sharedDataInfo: null,
    revokeCompleted: null,
    revokeOk: null,
}

export const shareDataReducerPublic = function (state = initialState, action) {
    switch (action.type) {
        case PUBLIC_DATA_REQUEST: {
            return {
                ...state,
                loadCompleted: false,
            }
        }

        case PUBLIC_DATA_OK: {
            const sharedData = action.sharedData
            return {
                ...state,
                loadCompleted: true,
                successfullyLoaded: true,
                sharedDataInfo: sharedData,
            }
        }

        case PUBLIC_DATA_ERROR: {
            return {
                ...state,
                loadCompleted: true,
                successfullyLoaded: false,
                sharedDataInfo: null,
            }
        }

        case PUBLIC_REVOKE_REQUEST: {
            return {
                ...state,
                revokeCompleted: false,
            }
        }

        case PUBLIC_REVOKE_OK: {
            const isOk = action.revokeReponse.ok
            return {
                ...state,
                revokeCompleted: true,
                revokeOk: isOk,
            }
        }

        case PUBLIC_REVOKE_ERROR: {
            return {
                ...state,
                revokeCompleted: true,
                revokeOk: false,
            }
        }

        default:
            return state
    }
}